"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CategoryTopicListView = _interopRequireDefault(require("@insided/deprecated-preact-components/widget-category-and-topic-stream/CategoryTopicListView.sync"));

var _service = require("@insided/destination/modules/Content/TopicList/service");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TabTopicList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TabTopicList, _Component);

  var _super = _createSuper(TabTopicList);

  function TabTopicList() {
    var _this$props$topics, _this$props$authors, _this$props$totalTopi;

    var _this;

    (0, _classCallCheck2.default)(this, TabTopicList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "TOPIC_CONTENT_LENGTH", 250);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      filteredTopics: (_this$props$topics = _this.props.topics) !== null && _this$props$topics !== void 0 ? _this$props$topics : [],
      authors: (_this$props$authors = _this.props.authors) !== null && _this$props$authors !== void 0 ? _this$props$authors : {},
      isLoading: false,
      query: _this.props.query,
      totalTopicsCount: (_this$props$totalTopi = _this.props.totalTopicsCount) !== null && _this$props$totalTopi !== void 0 ? _this$props$totalTopi : 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadTopics", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var mergeResults,
          requestUrl,
          query,
          _yield$fetchTopics,
          topics,
          total,
          authors,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mergeResults = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              requestUrl = _this.props.requestUrl;
              query = _this.state.query;
              _context.prev = 3;
              _context.next = 6;
              return (0, _service.fetchTopics)(requestUrl, query, true, _this.TOPIC_CONTENT_LENGTH, true);

            case 6:
              _yield$fetchTopics = _context.sent;
              topics = _yield$fetchTopics.topics;
              total = _yield$fetchTopics.total;
              authors = _yield$fetchTopics.authors;

              _this.setState(function (prevState) {
                return {
                  filteredTopics: mergeResults ? [].concat((0, _toConsumableArray2.default)(prevState.filteredTopics), (0, _toConsumableArray2.default)(topics)) : topics,
                  authors: mergeResults ? _objectSpread(_objectSpread({}, prevState.authors), authors) : authors,
                  totalTopicsCount: total,
                  isLoading: false
                };
              });

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              console.error('Error loading topics: ', _context.t0);

              _this.setState({
                isLoading: false
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 13]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMoreHandler", function () {
      _this.setState(function (prevState) {
        return {
          isLoading: true,
          query: _objectSpread(_objectSpread({}, prevState.query), {}, {
            pagination: _objectSpread(_objectSpread({}, prevState.query.pagination), {}, {
              page: prevState.query.pagination.page + 1
            })
          })
        };
      }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.loadTopics(true);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    });
    return _this;
  }

  (0, _createClass2.default)(TabTopicList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var filteredTopics = this.state.filteredTopics;

      if (!filteredTopics || filteredTopics.length === 0) {
        this.setState({
          isLoading: true
        }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this2.loadTopics(false);

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          filteredTopics = _this$state.filteredTopics,
          isLoading = _this$state.isLoading,
          totalTopicsCount = _this$state.totalTopicsCount,
          authors = _this$state.authors;
      return (0, _preact.h)(_CategoryTopicListView.default, {
        topics: filteredTopics,
        attachmentCdn: this.props.attachmentCdn,
        authors: authors,
        hasMore: Number(totalTopicsCount) > filteredTopics.length,
        onShowMore: this.showMoreHandler,
        isLoading: isLoading,
        wrapperClassName: (0, _classnames.default)('box widget', 'box__content', 'qa-widget-recent-topics', 'topic-list-view')
      });
    }
  }]);
  return TabTopicList;
}(_preact.Component);

var _default = TabTopicList;
exports.default = _default;